import {
  MonitoredCounterScrap,
  MonitoredCounterScrapCreateRequest,
  MonitoredCounterScrapUpdateRequest,
} from '../../types/app/monitoredCounterScrap.types';
import { api } from '../core/api';

export const getMonitoredCounterScrapsByDep = (departmentId: number) =>
  api
    .get<MonitoredCounterScrap[]>(`MonitoredCounterScrap/GetList/?parentId=${departmentId}`)
    .then((res) => res.data);

export const getMonitoredCounterScrap = (id: number) =>
  api.get<MonitoredCounterScrap>(`MonitoredCounterScrap/GetItem/?id=${id}`).then((res) => res.data);

export const updateMonitoredCounterScrap = (data: MonitoredCounterScrapUpdateRequest) =>
  api.put(`MonitoredCounterScrap/UpdateItem`, data).then((res) => res.data);

export const createMonitoredCounterScrap = (data: MonitoredCounterScrapCreateRequest) =>
  api.post(`MonitoredCounterScrap/CreateItem`, data).then((res) => res.data);

export const deleteMonitoredCounterScrap = (id: number) =>
  api.delete<MonitoredCounterScrap>(`MonitoredCounterScrap/DeleteItem/?id=${id}`).then();

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredCounterScrap/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
